import { render, staticRenderFns } from "./Breadcrumbs.vue?vue&type=template&id=6b61aee6&scoped=true&"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./Breadcrumbs.vue?vue&type=style&index=0&id=6b61aee6&lang=scss&scoped=true&"
import style1 from "./Breadcrumbs.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b61aee6",
  null
  
)

export default component.exports